var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _ellipse, _path0, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQrSuccess = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 159,
  height: 160,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#898989",
  d: "M31.626 92.639v5.052h5.057V87.586h-5.057zM36.682 62.326h-5.056v5.052h5.056zM67.92 117.904h-5.056v5.052h5.056z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#898989",
  d: "M36.683 72.428v5.052h-5.057v5.053h5.057v5.052h10.114v5.053h5.057v-5.053h5.057V77.48h-5.057v5.053H41.74V67.375h-5.057z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#898989",
  d: "M46.797 62.326H41.74v5.053h10.114v-5.053zM69.553 102.911h2.691v-5.052H66.78v5.052zM56.91 67.375h-5.056v5.052h5.056zM92.226 87.586H87.17v5.052h5.056zM97.283 32.092h-5.056v5.052h5.056zM67.024 72.43v-5.053h5.057v-5.053h-5.057v-5.052h-5.056v5.052H56.91v5.053h5.057v20.21h5.056V77.482h5.057v-5.053zM92.227 122.875h5.057v-5.053H87.17v5.053zM87.17 32.092h-5.057v5.052h5.056z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#898989",
  d: "M85.947 72.431V67.38H80.89v-5.053h-5.057v10.105h-5.057v5.053H80.89V72.43zM114.411 62.326h-5.056v5.052h5.056zM62.13 87.586h-5.056v5.052h5.056zM82.114 57.271V52.22h5.057v-5.053h10.114v-4.97h-5.057v-5.053h-5.057v5.052h-5.057v4.971H77.14v5.053h-5.057v5.052h10.032M82.114 92.64v-5.052h5.057v-5.053H77.14v5.053h-5.057v5.052h10.032M97.284 112.769v-5.052H87.171v-5.053h-5.058v5.053h-4.975v5.052H67.024v5.053h15.089v-5.053h5.058v5.053h5.056v-5.053zM77.138 37.144v-5.052H67.024v5.052h-5.057v5.053h10.114v-5.053z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#898989",
  d: "M77.138 42.195h-5.056v5.052h5.056zM89.699 62.324h-5.057v15.158000000000001h10.113v-5.053H89.7v-5.053h5.056v-5.052h5.057V57.27h-5.057V52.22H89.7v10.105M72.08 47.166h-5.056v5.052h5.056zM87.17 97.695v4.971h10.114v-4.97h10.114v-5.053H92.227v5.052zM114.411 77.482h-5.056v5.052h5.056zM97.283 82.535h-5.056v5.052h5.056zM109.926 67.375H99.813v5.053h5.056v5.052h5.057V67.375M107.397 82.535h-5.056v5.052h5.056zM51.854 112.853h15.17v-20.21H46.715v5.052H41.74v5.053h4.975v5.052H41.74v5.053h4.975v.081h.082v4.972H41.74v10.105h5.057v-5.053h5.057v-10.105m11.255-16.38v12.631H50.467V96.473zM117.512 92.639h5.057v-5.053h-15.171000000000001v5.052h10.114M117.512 72.431h5.057V62.326h-5.057v10.105M77.302 97.86h-5.057v10.105h5.057V97.859M127.624 92.643h-5.056v5.051h5.056z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#898989",
  d: "M127.625 82.535v-5.053h-5.057v10.106h5.057zM36.683 117.822h-5.057v10.105h5.057v-10.105M127.625 57.273V32.01h-25.284v25.263zm-21.451-3.749V35.84h17.699v17.684z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#898989",
  d: "M120.041 39.67h-10.114v10.105h10.114zM127.625 102.664h-25.284v25.263h25.284zm-21.451 21.514v-17.684h17.699v17.684z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#898989",
  d: "M120.041 110.244h-10.114v10.105h10.114zM31.626 32.092v25.263H56.91V32.092zm21.451 3.749v17.684h-17.7V35.84z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#898989",
  d: "M49.243 39.67H39.13v10.105h10.114z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#QrSuccess_svg__a)",
  opacity: 0.2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 79.498,
  cy: 80,
  r: 43.502,
  fill: "url(#QrSuccess_svg__b)"
}))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 79.499,
  cy: 80.004,
  fill: "url(#QrSuccess_svg__c)",
  rx: 20.011,
  ry: 20.012
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  stroke: "#76E22E",
  strokeOpacity: 0.5,
  strokeWidth: 1.523,
  d: "M98.748 80.005c0 10.632-8.618 19.25-19.25 19.25-10.63 0-19.249-8.618-19.249-19.25s8.619-19.251 19.25-19.251 19.25 8.618 19.25 19.25Z"
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#QrSuccess_svg__d)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#55C82D",
  d: "m67.1 80.835 8.808 8.79c.06.06.156.06.215 0L92.206 73.54a.15.15 0 0 0 0-.216l-3.22-3.221a.15.15 0 0 0-.216 0L76.119 82.756a.15.15 0 0 1-.216 0l-5.372-5.363a.15.15 0 0 0-.215 0l-3.217 3.226a.15.15 0 0 0 0 .216"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "QrSuccess_svg__b",
  x1: 79.498,
  x2: 79.498,
  y1: 36.498,
  y2: 123.502,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D4FE0F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#93F840"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "QrSuccess_svg__c",
  x1: 71.369,
  x2: 79.5,
  y1: 68.122,
  y2: 100.016,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DCFF01"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6BF63B"
})), /*#__PURE__*/React.createElement("filter", {
  id: "QrSuccess_svg__a",
  width: 158.405,
  height: 158.405,
  x: 0.295,
  y: 0.797,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur",
  stdDeviation: 17.85
})), /*#__PURE__*/React.createElement("filter", {
  id: "QrSuccess_svg__d",
  width: 25.196,
  height: 19.61,
  x: 67.055,
  y: 70.059,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.761
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow"
})))));
export { SvgQrSuccess as ReactComponent };
export default __webpack_public_path__ + "QrSuccess.4af20f08.svg";